import { useState } from "react";
import { downloadExport } from "../api";
import { useAuth } from "../auth";

export function DataOwnershipPage() {
  const { businessId, business } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  async function exportFile(
    file: "clients.csv" | "services.csv" | "bookings.csv",
  ) {
    if (!businessId) return;
    setError(null);
    setMessage(null);
    try {
      await downloadExport(businessId, file);
      setMessage(`Downloaded ${file}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Export failed");
    }
  }

  if (!businessId)
    return (
      <section>
        <p className="notice">No business selected.</p>
      </section>
    );

  return (
    <>
      <header className="page-header">
        <div>
          <p className="eyebrow">Data ownership</p>
          <h1>Your clients belong to you</h1>
        </div>
      </header>

      <section>
        <h2>Ownership commitment</h2>
        <p>
          {business?.name ?? "Your business"} owns its client relationships.
          DUTS Business does not sell client data, does not market competing
          businesses to your clients, and does not lock your records behind
          opaque formats.
        </p>
        <p>
          Export your clients, services, and bookings as CSV at any time. You
          control how that data is used outside the platform.
        </p>
      </section>

      <section>
        <h2>Export your data</h2>
        <div className="cta-row">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => void exportFile("clients.csv")}
          >
            Clients CSV
          </button>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => void exportFile("services.csv")}
          >
            Services CSV
          </button>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => void exportFile("bookings.csv")}
          >
            Bookings CSV
          </button>
        </div>
        {message ? <p className="notice">{message}</p> : null}
        {error ? <p className="notice error">{error}</p> : null}
      </section>
    </>
  );
}
